/* eslint-disable @atlaskit/editor/no-re-export */

export { useReference } from '../hooks/useReference';
